import DOMPurify from 'dompurify'
import React from 'react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { formValidation } from '../../../../utils/functions'
import Button from '../../../button'
import FormInput from '../../../form-input'
import FormSelect from '../../../form-select'
import FormSwitch from '../../../form-switch'
import LoadingBar from '../../../loader-bar'
import {
  useGetBanks,
  useGetPFA,
  useResolveBankAccount,
} from '../../../../redux/bank/hook'
import moment from 'moment'
import { AllCountries } from '../../../../constants/countries'
import { store } from '../../../../redux'
import { setAlert } from '../../../../redux/components/components-slice'
import classNames from 'classnames'
import {
  useActivateOrDeactivateVendor,
  useBulkActivateOrDeactivateVendors,
  useGetVendor,
  useUpdateVendor,
} from '../../../../redux/spend-management/vendor/hook'
import FormDatalist from '../../../form-datalist'
import SelectVendorPayOption from '../../../modal/spend-management/vendor/select-vendor-pay-option'

const VendorProfileTab = () => {
  useEffect(() => {}, [])

  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const { id } = useParams()
  const { data: vendor, isLoading } = useGetVendor(id)
  const [showSelectVendorPayOption, setShowSelectVendorPayOption] =
    useState(false)
  const [activateEmployee, setActivateEmployee] = useState(false)
  const { mutateAsync: updateVendor, isLoading: loading } = useUpdateVendor()

  const {
    mutateAsync: activateOrDeactivateVendor,
    isLoading: activateOrDeactivateLoading,
  } = useActivateOrDeactivateVendor()
  // const {
  //   mutateAsync: bulkActivateOrDeactivate,
  //   isLoading: bulkActivateOrDeactivateLoading,
  // } = useBulkActivateOrDeactivateVendors()
  const [gender, setGender] = useState('Male')
  const [country, setCountry] = useState('nigeria')

  const { mutateAsync: resolveAccount, isLoading: resolveAccountLoading } =
    useResolveBankAccount()
  const { data: banks, bankLoading } = useGetBanks()

  const [editMode, setEditMode] = useState(false)
  const [bankname, setBankName] = useState('')
  const [account_number, setAccountNumber] = useState('')
  const [account_name, setAccountName] = useState('')

  useEffect(() => {
    if (vendor) {
      setAccountName(vendor.account_name)
      setAccountNumber(vendor.account_number)
      setBankName(vendor.bank)
    }
  }, [vendor])

  useEffect(() => {
    if (account_number.length >= 10 && bankname !== '') {
      let payload = {
        bankname,
        account_number,
      }
      setAccountName('')
      resolveAccount(payload).then((response) => {
        setAccountName(response.data.accountname)
      })
    }
  }, [account_number, bankname])

  useEffect(() => {
    if (vendor) {
      setActivateEmployee(vendor?.status == 1 ? true : false)
      setGender(vendor?.gender)
      setCountry(vendor?.country)
    }
  }, [vendor])

  function submit(data) {
    const email = DOMPurify.sanitize(data?.email)
    const vendor_name = DOMPurify.sanitize(data?.vendor_name)
    const contact_person = DOMPurify.sanitize(data?.contact_person)
    const mobile = DOMPurify.sanitize(data?.mobile)
    const street_address = DOMPurify.sanitize(data?.street_address)
    const state = DOMPurify.sanitize(data?.state)
    const city = DOMPurify.sanitize(data?.city)
    const country = DOMPurify.sanitize(data?.country)
    const company = DOMPurify.sanitize(data?.company)

    let payload = {
      vendorId: id,
      data: {
        email,
        vendor_name,
        contact_person,
        mobile,
        street_address,
        state,
        city,
        country,
        company,
        bank: bankname,
        account_number: account_number,
        account_name: account_name,
      },
    }

    updateVendor(payload).then((result) => {
      setEditMode(false)
    })
  }

  const changeStatus = () => {
    if (vendor) {
      if (vendor.status == 0) {
        activateOrDeactivateVendor({
          type: 'activation',
          id: vendor.id,
        })
      } 
      
      // else if (vendor.status == 1) {
      //   activateOrDeactivateVendor({
      //     type: 'deactivation',
      //     id: vendor.id,
      //   })
      // }
    } else {
      store.dispatch(setAlert(true, 'info', 'No Vendor found'))
    }
  }

  return (
    <>
      {showSelectVendorPayOption ? (
        <SelectVendorPayOption
          isOpen={showSelectVendorPayOption}
          closeModal={() => setShowSelectVendorPayOption(false)}
        />
      ) : null}
      <div className='bg-white h-full w-full rounded'>
        <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
          <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
            Vendor Profile
          </div>
          <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full'>
            <div className='md:w-fit w-[100%]'>
              <Button
                text={
                  vendor?.status == 0 ? 'ACTIVATE VENDOR' : 'DEACTIVATE VENDOR'
                }
                type='button'
                className={classNames(
                  'flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center',
                  {
                    '!bg-red-500': vendor?.status == 1,
                    '!bg-hr-primary-1': vendor?.status !== 1,
                  }
                )}
                textClass={'!text-[11px]'}
                loading={activateOrDeactivateLoading}
                onClick={() => {
                  changeStatus()
                }}
              />
            </div>
            <div className='md:w-fit w-[100%]'>
              <Button
                text='PAY VENDOR'
                type='submit'
                theme='primary'
                className='flex gap-2 !h-[35px] w-fit p-2 '
                textClass={'!text-[11px]'}
                leftIcon={'add'}
                onClick={() => {
                  setShowSelectVendorPayOption(true)
                }}
              />
            </div>
          </div>
          {/* :
          null} */}
        </div>
        <hr className='divider' />
        {isLoading ? (
          <div className='flex flex-col w-full text-center justify-center pb-[25px] pt-[5px] px-4'>
            <LoadingBar loading={isLoading || loading} />
          </div>
        ) : (
          <>
            {vendor ? (
              <div className='px-4 pb-4'>
                <div className='w-full md:w-[20%] mt-2'>
                  <FormSwitch
                    label={'Edit Mode'}
                    name={'switch-edit-mode'}
                    checked={editMode}
                    onClick={() => setEditMode(!editMode)}
                    value={editMode}
                  />
                </div>
                {editMode ? (
                  <form
                    className='form border bg-gray-50 p-4 rounded-md w-full'
                    onSubmit={handleSubmit(submit)}
                  >
                    <div className={'flex flex-col mt-3 w-full '}>
                      <div className='flex flex-col md:flex-row justify-between'>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Vendor Name'
                            name='vendor_name'
                            type='text'
                            defaultValue={vendor?.vendor_name}
                            inputRef={register(formValidation('text', true))}
                            readOnly={loading}
                            error={errors.vendor_name}
                            errorMessage={
                              errors.vendor_name && errors.vendor_name.message
                            }
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Contact Person'
                            name='contact_person'
                            type='text'
                            defaultValue={vendor?.contact_person}
                            inputRef={register(formValidation('text', true))}
                            error={errors.contact_person}
                            errorMessage={
                              errors.contact_person &&
                              errors.contact_person.message
                            }
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Email'
                            name='email'
                            type='text'
                            inputRef={register(formValidation('email', true))}
                            defaultValue={vendor?.email}
                            error={errors.email}
                            errorMessage={errors.email && errors.email.message}
                          />
                        </div>
                      </div>
                      <div className='flex flex-col md:flex-row justify-between'>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Mobile'
                            name='mobile'
                            type='number'
                            inputRef={register(formValidation('number'))}
                            error={errors.mobile}
                            errorMessage={
                              errors.mobile && errors.mobile.message
                            }
                            defaultValue={vendor?.mobile}
                          />
                        </div>
                      </div>
                      <hr className='divider' />
                      <div className='flex flex-col md:flex-row justify-between'>
                        <div className='w-full md:w-[250px]'>
                          <FormSelect
                            defaultValue={country}
                            options={AllCountries}
                            onChange={(selected) => {
                              setCountry(selected)
                            }}
                            label='Country'
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='State'
                            name='state'
                            type='text'
                            defaultValue={vendor?.state}
                            inputRef={register(formValidation('text'))}
                            readOnly={loading}
                            error={errors.state}
                            errorMessage={errors.state && errors.state.message}
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='City'
                            name='city'
                            type='text'
                            defaultValue={vendor?.city}
                            inputRef={register(formValidation('text'))}
                            readOnly={loading}
                            error={errors.city}
                            errorMessage={errors.city && errors.city.message}
                          />
                        </div>
                      </div>
                      <div className='flex flex-col md:flex-row justify-between'>
                        <div className='w-full md:w-[750px]'>
                          <FormInput
                            label='Address'
                            name='street_address'
                            type='text'
                            defaultValue={vendor?.street_address}
                            inputRef={register(formValidation('text'))}
                            readOnly={loading}
                            error={errors.street_address}
                            errorMessage={
                              errors.street_address &&
                              errors.street_address.message
                            }
                          />
                        </div>
                      </div>
                      <hr className='divider' />
                      <div className='flex flex-col md:flex-row justify-between'>
                        <div className='w-full md:w-[250px]'>
                          <FormDatalist
                            label='Bank Name'
                            data={banks ? banks : []}
                            value={bankname}
                            onSelect={(value) => {
                              setAccountNumber('')
                              setBankName(value)
                            }}
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Account Number'
                            name='account_number'
                            type='text'
                            value={account_number}
                            error={errors.account_number}
                            errorMessage={
                              errors.account_number &&
                              errors.account_number.message
                            }
                            onInput={(e) => setAccountNumber(e.target.value)}
                          />
                        </div>
                        <div className='w-full md:w-[250px]'>
                          <FormInput
                            label='Account Name'
                            name='account_name'
                            type='text'
                            placeholder={
                              resolveAccountLoading
                                ? 'Fetching Account Name ....'
                                : ''
                            }
                            readOnly
                            inputRef={register(formValidation('text', true))}
                            value={account_name}
                            error={errors.account_name}
                            errorMessage={
                              errors.account_name && errors.account_name.message
                            }
                          />
                        </div>
                      </div>
                      <div className='flex items-center justify-end w-full mt-[20px]'>
                        <Button
                          text='Update Vendor Information'
                          type='submit'
                          loading={loading}
                          disabled={loading}
                          className='flex gap-2 !h-[35px] w-fit p-2 '
                          textClass={'!text-[11px]'}
                        />
                      </div>
                    </div>
                  </form>
                ) : (
                  <div className='flex flex-col md:flex-row border bg-gray-50 p-2 rounded-md'>
                    <div className='w-full md:w-[100%] px-4 pb-4'>
                      <div className='grid md:grid-cols-3  grid-cols-1 gap-4 w-full mt-3'>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Vendor Name
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.vendor_name
                              ? vendor.vendor_name
                              : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Contact Person
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.contact_person
                              ? vendor.contact_person
                              : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Email
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.email ? vendor.email : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Phone number{' '}
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.mobile ? vendor.mobile : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Date Created
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {moment(vendor.created).format('MMMM D, YYYY')}
                          </span>
                        </div>
                      </div>
                      <hr className='divider' />
                      <div className='grid md:grid-cols-3  grid-cols-1 gap-4 w-full mt-3'>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Country
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.country ? vendor.country : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            State
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {' '}
                            {vendor.state ? vendor.state : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>City</span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {' '}
                            {vendor.city ? vendor.city : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            {' '}
                            Address
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.street_address
                              ? vendor.street_address
                              : 'Not Set'}
                          </span>
                        </div>
                      </div>
                      <hr className='divider' />
                      <div className='grid md:grid-cols-3  grid-cols-1 gap-4 w-full mt-3'>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Bank Name
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {vendor.bank ? vendor.bank : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Account Number
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {' '}
                            {vendor.account_number
                              ? vendor.account_number
                              : 'Not Set'}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='header-6 text-color-gray'>
                            Account Name
                          </span>
                          <span className='mt-1 text-color-black text-[14px]'>
                            {' '}
                            {vendor.account_name
                              ? vendor.account_name
                              : 'Not Set'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  )
}

export default VendorProfileTab
